export enum ChartPosition {
  Top = 'top',
  Bottom = 'bottom',
}
